// extracted by mini-css-extract-plugin
module.exports = {"jq-tab-view-mobile-wrapper":"CourseTabViewMobile_jq-tab-view-mobile-wrapper__IPUPo"};